/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Avoid_Duplicates_LabelInputs */



/**
* | output |
* | --- |
* | "Avoid duplicate descriptions" |
*
* @param {Ad_Avoid_Duplicates_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_avoid_duplicates_label = /** @type {((inputs?: Ad_Avoid_Duplicates_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Avoid_Duplicates_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Évitez les descriptions en double.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vermeiden Sie doppelte Beschreibungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evita descrizioni duplicate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Избегайте дублирования описаний.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evite descripciones duplicadas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("避免重复描述。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複した説明を避ける")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक ही विवरण को दोहराने से बचें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evite descrições duplicadas")
	return /** @type {LocalizedString} */ ("Avoid duplicate descriptions")
});